import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useParams } from 'react-router-dom';
import PageLoader from '../../components/global/loader/PageLoader';
import jQuery from 'jquery';

import './styles.scss';
import { SingleInternalBanner } from '../../components/internals/SingleInternalBanner';

export const SingleBlog = () => {
  const { slug } = useParams();
  const [pageContent, setPageContent] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [author, setAuthor] = useState(null);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    document.title = 'Alinea Law PLLC';
    fetchPageContet(slug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const fetchPageContet = async (slug) => {
    setIsFetching(true);
    try {
      const { data } = await axios.get(
        `/wp-admin/admin-ajax.php?action=fetch_single_blog_by_slug&slug=${slug}`
      );

      console.log(data);

      if (data?.post) {
        if (data?.yoast_title?.length > 0) {
          const finalTitle = data.yoast_title
            .replace('%%title%%', data?.page?.post_title ? data?.page?.post_title : '')
            .replace('%%page%%', '')
            .replace('%%sep%%', '-')
            .replace('%%sitename%%', 'Alinea Law PLLC');

          document.title = finalTitle;
        } else {
          document.title = data?.post?.post_title
            ? `${data?.post?.post_title} - Alinea Law PLLC`
            : 'Alinea Law PLLC';
        }

        if (document.querySelector('#wp-admin-bar-edit a')) {
          document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Post`;
          document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.post?.ID}&action=edit`;
        }
      }

      setPageContent(data?.post ?? null);
      setAuthor(data?.author ?? null);
      setCategories(data?.categories ?? []);
      setFeaturedImage(data?.featured_image ?? null);

      setTimeout(() => {
        jQuery('#table-of-contents').html('');
        let toc = jQuery('#table-of-contents');
        let lastLevel = 2;
        let count = 0;

        jQuery('article h2, article h3').each(function () {
          count++;
          const heading = jQuery(this);
          const headingText = heading.text();

          const anchor = headingText
            .replace(/[^a-zA-Z0-9_ ]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase();

          heading.attr('id', anchor);

          const level = parseInt(this.tagName.substring(1), 10);

          if (level > lastLevel) {
            const sublist = jQuery('<ul>');
            toc.find('li:last').append(sublist);
            toc = sublist;
          } else if (level < lastLevel) {
            toc = toc.parents('ul').last();
          }

          lastLevel = level;

          if (anchor?.length > 1) {
            const listItem = jQuery('<li>').appendTo(toc);
            listItem.append(jQuery('<a>').attr('href', `#${anchor}`).text(headingText));
          }
        });

        if (count < 1) {
          jQuery('#table-of-contents').html("<li className='no-contents'>No Contents</li>");
          jQuery('#table-of-contents').addClass('no-contents');
        }

        jQuery('#table-of-contents a').on('click', function (e) {
          const elementId = jQuery(this).attr('href');

          const elementTop = jQuery(elementId).offset()?.top ?? 0;
          const viewportHeight = jQuery(window).height();
          const newScrollTop = elementTop - viewportHeight / 2;

          window.scrollTo({ top: newScrollTop, behavior: 'smooth' });
          e.stopPropagation();
          return false;
        });
      }, 600);

      window.addEventListener('scroll', highlightActiveItem);
    } catch (err) {
      console.log(err);
    } finally {
      setIsFetching(false);
    }
  };

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const highlightActiveItem = () => {
    const headings = jQuery('h2, h3');
    const tocLinks = jQuery('#table-of-contents a');

    headings.each(function () {
      if (isElementInViewport(this)) {
        tocLinks.removeClass('active');
        const currentAnchor = jQuery(this).attr('id');
        tocLinks.filter(`[href='#${currentAnchor}']`).addClass('active');
      }
    });
  };

  /**
   * SAFEGUARD 1:
   * If your backend starts returning a rendered field, use it automatically.
   * This prevents Gutenberg block comments (<!-- wp:... -->) from showing.
   */
  const htmlToRender = useMemo(() => {
    // Preferred if your PHP returns rendered HTML (recommended):
    if (pageContent?.post_content_rendered) return pageContent.post_content_rendered;

    // Alternate common naming:
    if (pageContent?.content_rendered) return pageContent.content_rendered;

    // Fallback to your existing field:
    return pageContent?.post_content || '';
  }, [pageContent]);

  /**
   * SAFEGUARD 2:
   * If Gravity Forms scripts are present, trigger post-render hooks after content mount.
   * Safe no-op if GF is not on the page.
   */
  useEffect(() => {
    if (isFetching) return;
    if (!htmlToRender) return;

    // Let DOM paint first
    const t = setTimeout(() => {
      try {
        // Some sites rely on these events after injecting content dynamically
        if (window?.jQuery) {
          window.jQuery(document).trigger('gform_post_render', [1, 1]);
          window.jQuery(document).trigger('gform_page_loaded', [1, 1]);
        }
        if (window?.gform?.core?.triggerPostRenderEvents) {
          // If multiple forms exist, this won’t hurt; it’s a best-effort hook.
          window.gform.core.triggerPostRenderEvents(1, 1);
        }
      } catch (e) {
        // no-op
      }
    }, 50);

    return () => clearTimeout(t);
  }, [isFetching, htmlToRender]);

  return (
    <Fade delay={1}>
      <main id="main" className="internal-page single">
        {!isFetching && (
          <>
            <SingleInternalBanner page={pageContent} author={author} categories={categories} />
            <section id="main-article-content">
              <div className="container">
                <div className="inner-sidebar-page-wrapper">
                  <article dangerouslySetInnerHTML={{ __html: htmlToRender }} />
                  <aside>
                    {featuredImage && (
                      <div className="featured-image" dangerouslySetInnerHTML={{ __html: featuredImage }} />
                    )}
                    <div className="toc-wrapper">
                      <span className="title">Page Contents</span>
                      <ul id="table-of-contents" />
                    </div>
                  </aside>
                </div>
              </div>
            </section>
          </>
        )}

        {isFetching && <PageLoader />}
      </main>
    </Fade>
  );
};
